import * as React from 'react';
import {DragDropContext} from 'react-beautiful-dnd';

import {SlackAuthBanner} from 'shells/form/slack/slack-auth-banner';

import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {SLACK} from '../../constants';

import {calculateBoardWidth} from '../calculate-board-width';
import {ClosedLeadSlackContainer} from '../card-containers/closed-lead-slack-container';

import {CollapsibleSection} from './collapsible-section';

const BOARD_WIDTH = calculateBoardWidth(3);

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
    hasSlackIntegration: boolean | null | undefined;
};

export function ClosedLeadSlackAutomations(props: Props) {
    return (
        <DragDropContext onDragEnd={() => {}}>
            <CollapsibleSection type={SLACK}>
                {props.hasSlackIntegration ? (
                    ['LEAD_WON', 'LEAD_LOST', 'LEAD_CANCELLED'].map((outcomeType) => (
                        <ClosedLeadSlackContainer
                            key={outcomeType}
                            // @ts-expect-error
                            outcomeType={outcomeType}
                            isLoading={props.isLoading}
                            errorMessage={props.errorMessage}
                            closedLeadAutomations={props.closedLeadAutomations}
                        />
                    ))
                ) : (
                    <SlackAuthBanner
                        width={BOARD_WIDTH}
                        text='Connect with Slack to update your team when leads are won, or when they enter a particular stage'
                    />
                )}
            </CollapsibleSection>
        </DragDropContext>
    );
}
